import { TicketMessageCard } from "@/components/domain/ticket-message-card"
import { useCurrentRole } from "@/lib/authz"
import type { TicketMessage } from "@/types/ticket"

type Props = { messages: TicketMessage[] }

// Tool-call chips are platform internals. Hide them from non-admin
// operators in the production ticket view; designer + test panes still
// see them via ChatMessageBubble's default.
const TOOLCALL_VISIBLE_ROLES = new Set(["admin", "super_admin"])

// Scrollable conversation transcript. Each message renders as a flat
// full-width card via TicketMessageCard, which dispatches to the right
// variant by role (regular / tool event / internal note).
export function TicketThread({ messages }: Props) {
  const role = useCurrentRole()
  const showToolCalls = TOOLCALL_VISIBLE_ROLES.has(role ?? "")

  if (messages.length === 0) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-app-muted">
        No messages yet.
      </div>
    )
  }

  return (
    <div className="flex flex-1 flex-col gap-1.5 overflow-y-auto px-4 py-2">
      {messages.map((m) => (
        <TicketMessageCard key={m.id} msg={m} showToolCalls={showToolCalls} />
      ))}
    </div>
  )
}
